import AttachmentList from './src/main';

/* istanbul ignore next */
AttachmentList.install = function(Vue) {
  Vue.component(AttachmentList.name, AttachmentList);
};

export default AttachmentList;
